export const propertyFilters = [
  { key: 'alle', label: 'Alle boliger' },
  { key: 'ledig', label: 'Ledige boliger' },
  { key: 'opptatt', label: 'Opptatte boliger' },
];

export const propertySortOptions = [
  { key: 'standard', label: 'Standard rekkefolge' },
  { key: 'nyeste', label: 'Nyeste forst' },
  { key: 'storrelse-stor', label: 'Storrelse: stor til liten' },
  { key: 'storrelse-liten', label: 'Storrelse: liten til stor' },
  { key: 'navn', label: 'Navn: A til A' },
];

export const propertyUnitOptions = [
  { value: 0, label: 'Alle storrelser' },
  { value: 5, label: '5+ boenheter' },
  { value: 10, label: '10+ boenheter' },
  { value: 15, label: '15+ boenheter' },
];

export const navigation = [
  { label: 'Om oss', href: '#om-oss' },
  { label: 'Eiendomstyper', href: '#eiendomstyper' },
  { label: 'Eiendommer', href: '#eiendommer' },
  { label: 'Kontakt', href: '#kontakt' },
];